import { render } from "./ProductQuickBuyModal.vue?vue&type=template&id=3fc8033a"
import script from "./ProductQuickBuyModal.vue?vue&type=script&lang=js"
export * from "./ProductQuickBuyModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__